import React from "react";
import { Box } from "@mui/material";
import TaskDetails from "../../components/Tasks/TaskDetails";

function Tasks() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        pt: { xs: 1, sm: 1.5, md: 2, lg: 2, xl: 2 },
        px: { xs: 1, sm: 1.5, md: 2, lg: 2, xl: 2 },
        pb: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 },
        boxSizing: "border-box",
      }}
    >
      <TaskDetails />
    </Box>
  );
}

export default Tasks;
